import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Flex, AccordionList, Accordion } from 'onefaceui-react-components';

import { getResourceTo } from 'react/utils/utils';

const ServiceTimeType = ({ stop, routeId, stopId }) => {
  const serviceTimeType = useMemo(() => {
    const location = stop.getIn(['location', 'serviceTimeType'], '');

    return location ? location.get('description') : '';

  }, [stop, routeId, stopId]);

  return (
    serviceTimeType && (
      <AccordionList>
        <Accordion
          dataTestId="serviceTimeType"
          label={getResourceTo('Stop.popup.ServiceTimeType')}
        >
          <Flex alignItems="center" className="serviceTime-item">
            <div>{serviceTimeType}</div>
          </Flex>
        </Accordion>
      </AccordionList>
    )
  );
}

ServiceTimeType.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  stop: PropTypes.object.isRequired
}

export default ServiceTimeType;
